export default [
  {
    path: '/policyFiles',
    redirect: '/policyFiles/schoolPolicy',
    component: () => import('@/views/policy-files/index.vue'),
    children: [
      {
        path: 'schoolPolicy',
        name: 'school-policy',
        component: () => import('@/views/policy-files/school-policy/index.vue'),
        meta: {
          title: '学校政策',
        },
      },
      {
        path: 'schoolPolicy/detail',
        name: 'school-policy-detail',
        component: () => import('@/views/policy-files/school-policy/detail.vue'),
        meta: {
          title: '学校政策详情',
        },
      },
      {
        path: 'provincePolicy',
        name: 'province-policy',
        component: () => import('@/views/policy-files/province-policy/index.vue'),
        meta: {
          title: '省市政策',
        },
      },
      {
        path: 'provincePolicy/detail',
        name: 'province-policy-detail',
        component: () => import('@/views/policy-files/province-policy/detail.vue'),
        meta: {
          title: '省市政策详情',
        },
      },
      {
        path: 'countryPolicy',
        name: 'country-policy',
        component: () => import('@/views/policy-files/country-policy/index.vue'),
        meta: {
          title: '国家政策',
        },
      },
      {
        path: 'countryPolicy/detail',
        name: 'country-policy-detail',
        component: () => import('@/views/policy-files/country-policy/detail.vue'),
        meta: {
          title: '国家政策详情',
        },
      },
    ],
  },
];

